import React from 'react';
import markdownHelpers from '../../helpers/markdown';
import { TestimonialProps } from '../../types/components/pricing/Testimonial';

const Testimonial: React.FC<TestimonialProps> = ({
  quote,
  author,
  authorTitle,
}) => {
  const { convertMarkdownToHtml } = markdownHelpers;

  return (
    <div className="flex px-4 md:px-0 flex-col gap-4 w-full mt-4 items-center" cy-test-id="testimonial">
      <div className="inter md:text-40 font-bold md:leading-[60px] max-w-[1063px] text-center" cy-test-id="quote">
        “{quote}”
      </div>
      <div className="flex max-md:items-center gap-1 md:gap-4 flex-col md:flex-row inter text-14 md:text-21 md:leading-28 font-normal text-a-gray">
        <span cy-test-id="author">{author}</span>
        <span className="max-md:hidden h-[28px] border-r-[1px] border-blue-1000 border-solid"/>
        <span
          cy-test-id="author-title"
          dangerouslySetInnerHTML={{
            __html: convertMarkdownToHtml(authorTitle)
          }}
        />
      </div>
    </div>
  );
};

export default Testimonial;
